import React from 'react'
import { MappedErrorMessageState } from 'types/errors'
import { DisplayErrorMessage } from './DisplayErrorMessage'
import { RequestError } from './RequestError'

interface RequestErrorCalloutProps {
  requestError: MappedErrorMessageState
}

export const RequestErrorCallout = ({ requestError }: RequestErrorCalloutProps) => {
  return (
    <RequestError errorCode={requestError?.errorCode} sentryTraceId={requestError?.sentryTraceId}>
      {requestError?.ErrorMessages ? (
        <DisplayErrorMessage displaySubTitle errorDetails={requestError?.ErrorMessages ?? {}} />
      ) : (
        requestError?.handledMessage
      )}
    </RequestError>
  )
}
